<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="medium" (click)="dismiss()">Close</ion-button>
    </ion-buttons>
    <ion-title>Payment Complete</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="success-message" style="text-align: center;">
    <ion-icon name="checkmark-circle" size="large" color="success"></ion-icon>
    <h2>Payment Successful!</h2>
    <p>Your payment has been processed successfully.</p>
  </div>
  <ion-button expand="full" (click)="dismiss()">Ok</ion-button>
  <ion-button expand="full" (click)="downloadInvoice()">Download Invoice</ion-button>
</ion-content>